import { render, staticRenderFns } from "./HelpfulLinkShow.vue?vue&type=template&id=60d001c5"
import script from "./HelpfulLinkShow.vue?vue&type=script&lang=ts"
export * from "./HelpfulLinkShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports